var _path, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadascsvicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35656 9.91645V3.13867C4.35656 2.58639 4.80428 2.13867 5.35656 2.13867H18.0415C18.3067 2.13867 18.5611 2.24403 18.7486 2.43157L21.5656 5.24856C21.7531 5.43609 21.8585 5.69045 21.8585 5.95566V22.5276C21.8585 23.0798 21.4158 23.5276 20.8635 23.5276C17.9564 23.5276 9.30844 23.5276 3.38628 23.5276M16.9974 2.13867V5.99978C16.9974 6.55207 17.4451 6.99978 17.9974 6.99978H21.8585M6.30295 13.8053H4.35851C3.38628 13.8053 2.41406 14.2915 2.41406 15.2637V18.1803C2.41406 19.1526 3.38628 19.6387 4.35851 19.6387H6.30295M12.3793 13.8053H9.94878C8.49045 13.8053 8.00434 14.2915 8.00434 15.2637C8.00434 16.2359 8.49045 16.722 9.94878 16.722C11.4071 16.722 11.8932 17.2081 11.8932 18.1803C11.8932 19.1526 11.4071 19.6387 9.94878 19.6387H7.51823M19.4279 12.8331V13.3192C19.4279 13.7484 17.5332 18.346 17.0895 19.4167C17.0332 19.5527 16.9015 19.6387 16.7543 19.6387V19.6387C16.6072 19.6387 16.4755 19.5527 16.4191 19.4167C15.9755 18.346 14.0807 13.7484 14.0807 13.3192V12.8331",
    stroke: "#008D9C",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_80_40780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 3,
    width: 8,
    height: 9
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.82812,
    y: 3.5,
    width: 7,
    height: 8.16667,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_80_40780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4826 11.2517L9.99219 8.76131L10.607 8.12869L12.0451 9.56675V4.66675H12.9201V9.56675L14.3581 8.12869L14.973 8.76131L12.4826 11.2517Z",
    fill: "#008D9C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadascsvicon);
export default __webpack_public_path__ + "static/media/download as csv icon.0dc96d79165658e72992d447122fe10a.svg";
export { ForwardRef as ReactComponent };